import React from 'react';
import { Link } from 'react-router-dom';
import { Permission } from '../../../utils/helpers/permissions';
import PermissionGate from '../../../utils/hooks/PermissionGate';
import { Questions } from './Components/Questions';

export const QuestionBank = () => {
  return (
    <div className='min-w-0'>
      <nav
          className='flex w-full flex-col gap-2 border-b border-slate-200 py-2 text-sm lg:flex-row lg:items-center lg:justify-between'
          aria-label='Breadcrumb'
      >
        <ol className='inline-flex items-center gap-2'>
          <li>
            <Link to={'#'} className='text-primary-textGray hover:underline'>
              Questions
            </Link>
          </li>
          <li>
            <span className='text-gray-400'>/</span>
          </li>
          <li>
            <Link
                to={'#'}
                className='text-primary-main font-semibold hover:underline'
            >
              Question bank
            </Link>
          </li>
        </ol>
        <div className='flex flex-wrap gap-2 lg:gap-4'>
          <PermissionGate
              requiredPermissions={[Permission.QUESTIONS_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-xs font-semibold text-primary-main hover:bg-emerald-50 lg:text-sm'
                to={'/pre-screen-bank'}
            >
              Pre Screen Question Bank
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.JOB_VIEW]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-xs font-semibold text-primary-main hover:bg-emerald-50 lg:text-sm'
                to={'/content-manager'}
            >
              Content Manager
            </Link>
          </PermissionGate>
          <PermissionGate
              requiredPermissions={[Permission.JOB_CREATE]}
              matchAnyPermission={false}
          >
            <Link
                className='rounded-md px-2 py-1 text-xs font-semibold text-primary-main hover:bg-emerald-50 lg:text-sm'
                to={'/upload-file'}
            >
              Auto Generate Questions
            </Link>
          </PermissionGate>
        </div>
      </nav>

      <h2 className='mb-2 rounded-b-lg bg-primary-light px-3 py-1.5 text-center text-xs font-medium text-primary-textGray'>
        You can view all the questions that are used in all the assessments.
      </h2>
      <div>
        <Questions />
      </div>
    </div>
  );
};
